<template>
    <div>
        <h3 style="text-align: center">สลิปเงินเดือน</h3>
        <div class="row form-group">
            <div class="col-4 text-right">แผนก</div>
            <div class="col-6">
                <multiselect
                        :options="optionDepartment"
                        v-model="search.department"
                        label="department_name"
                        select-label=""
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">พนักงาน</div>
            <div class="col-6">
                <multiselect
                        v-model="search.employee"
                        :options="optionEmployee"
                        label="name"
                        placeholder="ค้นหาพนักงาน"
                        :show-labels="false"
                        :customLabel="employeeLabel"
                        track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">เดือน</div>
            <div class="col-6">
                <multiselect
                        label="name"
                        placeholder="เลือกเดือน"
                        :options="optionMonth"
                        v-model="search.month"
                        track-by="value"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">วีค</div>
            <div class="col-6">
                <multiselect
                        label="name"
                        placeholder="เลือกวีค"
                        :options="optionWeek"
                        v-model="search.week"
                        track-by="value"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="col text-center">
            <button  type="button"
                     @click="submitData"
                     class="btn btn-success">
                <icon name="print" style="width: 25px"></icon>
                ตกลง
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    export default {
        name: "FilterSalaryModal",
        components:{
            Multiselect,
        },
        data(){
            return{
                search :{
                    date : [],
                    employee : '',
                    week : '',
                    month : '',
                    department : '',
                },
                optionEmployee : [],
                optionDepartment : [],
                optionWeek : [
                    { name: 'วีค 1', value: '1'},
                    { name: 'วีค 2', value: '2' }
                ],
                optionMonth : [
                    { name: 'มกราคม', value: '1'},
                    { name: 'กุมภาพันธ์', value: '2'},
                    { name: 'มีนาคม', value: '3'},
                    { name: 'เมษายน', value: '4'},
                    { name: 'พฤษภาคม', value: '5'},
                    { name: 'มิถุนายน', value: '6'},
                    { name: 'กรกฎาคม', value: '7'},
                    { name: 'สิงหาคม', value: '8'},
                    { name: 'กันยายน', value: '9'},
                    { name: 'ตุลาคม', value: '10'},
                    { name: 'พฤศจิกายน', value: '11'},
                    { name: 'ธันวาคม', value: '12'}
                ],
            }
        },
        created() {
            this.getEmployeeAll();
            this.$store.dispatch("Employee/setEmployee");
            this.getDepartmentAll();
        },
        methods:{
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            getEmployeeAll(){
                this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                    this.optionEmployee = res;
                })
            },
            submitData(){
                if(this.search.department == '' && this.search.employee == ''){
                    alert('กรุณาเลือกพนักงาน หรือแผนก');
                }else{
                    let data = {
                        employee_no : this.search.employee ? this.search.employee.employee_no : '',
                        week : this.search.week ? this.search.week.value : '',
                        month : this.search.month ? this.search.month.value : '',
                        department : this.search.department ? this.search.department.id : '',
                    };
                    console.log(data);
                    this.$emit("submit",data);
                }
            },
            cancelData(){
                this.$emit("submit",false);
            },
            getDepartmentAll(){
                this.$store.dispatch("Department/getAllDepartment").then(res=>{
                    this.optionDepartment = res;
                })
            },
        }
    }
</script>

<style scoped>

</style>
